import React from 'react';
import { QuestionnaireResult } from '../../../../../graphql/graphql';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import { Size } from '../../../../../Enums/Size.enum';
import QuestionnaireResultsWithScoringListItemDetailedScoring from './QuestionnaireResultsWithScoringListItemDetailedScoring';

interface Props extends BaseModalProps {
	item: QuestionnaireResult;
}

const QuestionnaireResultsWithScoringListItemDetailedScoringModal: React.FC<
	Props
> = props => {
	return (
		<BaseModal {...props} title='base.questionnaireResult.one' size={Size.LG}>
			<QuestionnaireResultsWithScoringListItemDetailedScoring
				item={props.item}
			/>
		</BaseModal>
	);
};

export default QuestionnaireResultsWithScoringListItemDetailedScoringModal;
